import VideoOnVideoInfo from "../models/VideoOnVideoInfo"
export default function MockVovDataService() {
  var data = [
    {
      id: "5888",
      duration: "00:01:40.5400000",
      is_gated: true,
      title: "What's going on with Energy & Power these days?",
      description:
        "Nathan describes the OpenAPI best practices he has observed. Among them is getting early feedback, building realistic tests, and making sure users know of changes.",

      video_big: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/f53d10c1-7804-4533-b111-8c0fbb8ba6a1/a2f7f617f4da2fe8.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/f53d10c1-7804-4533-b111-8c0fbb8ba6a1/a2f7f617f4da2fe8.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/53da0e87b6c22238.jpg"
      },
      video_small: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/077254ee-f47d-4c94-8188-504e5c9a5bf5/3cf0137b9f1de7d0.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/077254ee-f47d-4c94-8188-504e5c9a5bf5/3cf0137b9f1de7d0.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/9ec1efef869a94f9.jpg"
      },
      subtitle_urls: {
        srt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5888.srt",
        web_vtt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5888.vtt"
      }
    } as VideoOnVideoInfo,
    {
      id: "5894",
      duration: "00:01:20.3200000",
      is_gated: true,
      title: "Rationalization of portfolios",
      description:
        "Nathan describes the OpenAPI best practices he has observed. Among them is getting early feedback, building realistic tests, and making sure users know of changes.",

      video_big: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/09f639f8-45ee-4b8c-aff9-aef62f5b4548/a2f7f617f4da2fe8.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/09f639f8-45ee-4b8c-aff9-aef62f5b4548/a2f7f617f4da2fe8.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/9398cd88337ef83d.jpg"
      },
      video_small: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/f602d172-fdf8-4df9-8d7e-6067d1f4e69d/3cf0137b9f1de7d0.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/f602d172-fdf8-4df9-8d7e-6067d1f4e69d/3cf0137b9f1de7d0.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/9b6dbbd5ba5ab9e0.jpg"
      },
      subtitle_urls: {
        srt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5889.srt",
        web_vtt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5889.vtt"
      }
    } as VideoOnVideoInfo,
    {
      id: "5890",
      duration: "00:01:01.4400000",
      is_gated: true,
      title: "Lots of activity in renewable space",
      description:
        "Nathan describes the OpenAPI best practices he has observed. Among them is getting early feedback, building realistic tests, and making sure users know of changes.",

      video_big: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/342f1427-1eba-4f38-aacb-f2560a4afce2/a2f7f617f4da2fe8.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/342f1427-1eba-4f38-aacb-f2560a4afce2/a2f7f617f4da2fe8.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/9e5fb7696bb1faf4.jpg"
      },
      video_small: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/4859bbb4-facd-4cc4-8fe6-f52a97efc861/3cf0137b9f1de7d0.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/4859bbb4-facd-4cc4-8fe6-f52a97efc861/3cf0137b9f1de7d0.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/cf2b3db49560237f.jpg"
      },
      subtitle_urls: {
        srt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5890.srt",
        web_vtt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5890.vtt"
      }
    } as VideoOnVideoInfo,
    {
      id: "5896",
      duration: "00:02:06.6900000",
      is_gated: true,
      title: "Situation in the private markets",
      description:
        "Nathan describes the OpenAPI best practices he has observed. Among them is getting early feedback, building realistic tests, and making sure users know of changes.",

      video_big: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/6d2f6e34-bcec-4d19-a3e7-acfb9fed10ac/a2f7f617f4da2fe8.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/6d2f6e34-bcec-4d19-a3e7-acfb9fed10ac/a2f7f617f4da2fe8.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/e041494caf7a4289.jpg"
      },
      video_small: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/1eb35300-1420-4054-81ed-28458ea8fa59/3cf0137b9f1de7d0.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/1eb35300-1420-4054-81ed-28458ea8fa59/3cf0137b9f1de7d0.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/7158efd12da440b1.jpg"
      },
      subtitle_urls: {
        srt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5891.srt",
        web_vtt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5891.vtt"
      }
    } as VideoOnVideoInfo,
    {
      id: "5892",
      duration: "00:00:48.7200000",
      is_gated: true,
      title: "Alternative Energy",
      description:
        "Nathan describes the OpenAPI best practices he has observed. Among them is getting early feedback, building realistic tests, and making sure users know of changes.",

      video_big: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/beb512bc-72cb-43dd-a404-6c2ad4816dd6/a2f7f617f4da2fe8.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/beb512bc-72cb-43dd-a404-6c2ad4816dd6/a2f7f617f4da2fe8.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/59e11611a0577466.jpg"
      },
      video_small: {
        dash_url:
          "https://amplilymedia-usea.streaming.media.azure.net/bba71b13-55f7-40c0-baec-7fdee6e449fc/3cf0137b9f1de7d0.ism/manifest(format=mpd-time-csf)",
        hls_url:
          "https://amplilymedia-usea.streaming.media.azure.net/bba71b13-55f7-40c0-baec-7fdee6e449fc/3cf0137b9f1de7d0.ism/manifest(format=m3u8-aapl)",
        poster_url:
          "https://amplilyimagecap.blob.core.windows.net/screenshots/608591913d033942.jpg"
      },
      subtitle_urls: {
        srt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5892.srt",
        web_vtt_url:
          "https://subtitles.blob.core.windows.net/subs/f0983ae77fa3e0ce/5892.vtt"
      }
    } as VideoOnVideoInfo
  ]

  return data
}
